// extracted by mini-css-extract-plugin
module.exports = {"add":"add___1kYph","input":"input___lkjsh","remove":"remove___34PU6","item":"item___xpMg9"};